import { r as registerInstance, h } from './index-5faac9d7.js';
import { t as tryParse } from './index-39f51a91.js';
import { D as Direction } from './types-e54f4a51.js';
import { g as getContextDirection } from './contextDirection-33f260e3.js';
import './currency-49e0d692.js';
import './_commonjsHelpers-7db8bc26.js';
import './analytics-b3108572.js';
import './lodash-7f024380.js';
import './_nodeUtil-549406aa.js';
import './_Stack-cf94d4e7.js';

const myProductsPdsCss = "@page {width:595px;height:975px;counter-increment:page}";

const MyProductsPDS = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this._productsInfo = undefined;
    this._productsTitle = undefined;
    this._allProductLabels = undefined;
    this.productsInfo = undefined;
    this.myProductsHeaderTitle = undefined;
    this.productsTitle = undefined;
    this.allProductsLabels = undefined;
    this.contextDirection = undefined;
  }
  componentWillLoad() {
    var _a, _b, _c, _d;
    this.productsInfo = (_a = tryParse(this._productsInfo)) !== null && _a !== void 0 ? _a : this.productsInfo;
    this.productsTitle = (_b = tryParse(this._productsTitle)) !== null && _b !== void 0 ? _b : this.productsTitle;
    this.allProductsLabels = (_c = tryParse(this._allProductLabels)) !== null && _c !== void 0 ? _c : this.allProductsLabels;
    const configDirection = (_d = this.allProductsLabels.context) === null || _d === void 0 ? void 0 : _d.direction;
    this.contextDirection = getContextDirection(configDirection);
  }
  getProductList() {
    var _a;
    if (!((_a = this.productsTitle.lists) === null || _a === void 0 ? void 0 : _a.length))
      return [];
    const productGroups = this.productsTitle.lists.map((list) => {
      var _a;
      return (_a = list.products) === null || _a === void 0 ? void 0 : _a.map((product) => {
        return {
          productId: product.commRef,
          description: product.commDesc,
        };
      });
    });
    return productGroups.flat(2) || [];
  }
  getDataSheetTitles() {
    if (!this.productsTitle.lists.length || !this.productsTitle.lists[0].products.length) {
      return {
        dataSheetTableOfContent: '',
        dataSheetDate: '',
      };
    }
    const { dataSheetTableOfContent, dataSheetDate } = this.productsTitle.lists[0].products[0];
    return {
      dataSheetTableOfContent,
      dataSheetDate,
    };
  }
  render() {
    var _a, _b;
    const { dataSheetTableOfContent, dataSheetDate } = this.getDataSheetTitles();
    const { dataSheetListTitle, dataSheetTitle, dataSheetDisclaimer } = this.productsInfo;
    const { productCharacteristicsLabel } = this.productsInfo.specifications;
    const { ctaArea } = ((_a = this.productsInfo) === null || _a === void 0 ? void 0 : _a.base) || {};
    const { weeePriceLabel } = (ctaArea === null || ctaArea === void 0 ? void 0 : ctaArea.weeePrices) || {};
    return (h("div", { class: "pdf-rtl-selector", dir: (_b = this.contextDirection) !== null && _b !== void 0 ? _b : Direction.auto }, h("cover-page", { date: dataSheetDate, title: dataSheetListTitle }), h("my-products-pds-toc", { contextDirection: this.contextDirection, productDesc: this.getProductList(), tocTitle: dataSheetTableOfContent }), h("pes-my-products-pds-first-product-page", { title: dataSheetTitle, subtitle: productCharacteristicsLabel, disclaimer: dataSheetDisclaimer, weeePriceLabel: weeePriceLabel, contextDirection: this.contextDirection })));
  }
};
MyProductsPDS.style = myProductsPdsCss;

export { MyProductsPDS as my_products_pds };
